import { render, staticRenderFns } from "./Sideview.vue?vue&type=template&id=5a33e22c"
import script from "./Sideview.vue?vue&type=script&lang=js"
export * from "./Sideview.vue?vue&type=script&lang=js"
import style0 from "./Sideview.vue?vue&type=style&index=0&id=5a33e22c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports